var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("el-alert", {
            attrs: {
              type: "success",
              closable: false,
              title:
                "路由存储指当前路由的存储区域，\n        不同路由之间存储不会相互干扰，\n        使用 await this.$store.dispatch('d2admin/db/databasePage') 获得存储实例进行操作，\n        不同路由条件下获取的存储实例指向位置不同，\n        可以指定路由区分依据 name | path | fullPath，\n        默认根据路由的 name 区分不同的路由"
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("p", { staticClass: "d2-mt-0" }, [_vm._v("增加不重复字段")]),
              _c("el-button", { on: { click: _vm.handleSetRandom } }, [
                _vm._v("增加")
              ]),
              _c("p", [_vm._v("增加自定义字段")]),
              _c("el-input", {
                staticClass: "d2-mr-5",
                staticStyle: { width: "100px" },
                attrs: { placeholder: "字段名" },
                model: {
                  value: _vm.keyNameToSet,
                  callback: function($$v) {
                    _vm.keyNameToSet = $$v
                  },
                  expression: "keyNameToSet"
                }
              }),
              _c("el-input", {
                staticClass: "d2-mr-5",
                staticStyle: { width: "100px" },
                attrs: { placeholder: "值" },
                model: {
                  value: _vm.valueToSet,
                  callback: function($$v) {
                    _vm.valueToSet = $$v
                  },
                  expression: "valueToSet"
                }
              }),
              _c("el-button", { on: { click: _vm.handleSet } }, [
                _vm._v("增加")
              ]),
              _c("p", [_vm._v("删除字段")]),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择要删除的 key" },
                  model: {
                    value: _vm.keyNameToDelete,
                    callback: function($$v) {
                      _vm.keyNameToDelete = $$v
                    },
                    expression: "keyNameToDelete"
                  }
                },
                _vm._l(_vm.keyNameList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              ),
              _c("p", [_vm._v("清空当前用户数据")]),
              _c("el-button", { on: { click: _vm.handleClear } }, [
                _vm._v("清空")
              ])
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [_c("d2-highlight", { attrs: { code: _vm.dataDisplay } })],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }